/** MODU 성인 콧물 흡입기 — 제품 디자인 케이스 데이터 */

export const MODU_INHALER_SLUG = 'modu-inhaler'

export const MODU_INHALER_SHEET_IMG = '/assets/img/design/modu-inhaler-sheet.png'
export const MODU_INHALER_COLLAGE_IMG = '/assets/img/design/modu-inhaler-collage.png'
export const MODU_INHALER_STUDIO_IMG = '/assets/img/design/modu-inhaler-studio.png'

export const moduInhalerPortfolioCard = {
    slug: MODU_INHALER_SLUG,
    title: 'MODU 성인 콧물 흡입기',
    excerpt:
        '휴대·간편 조작을 전제한 프리미엄 흡입기 — 스테인리스 포인트, 3단 출력 UI, USB-C 충전 구조입니다.',
    image: MODU_INHALER_STUDIO_IMG,
    imageAlt: 'MODU 성인 콧물 흡입기 — 스튜디오 3D 렌더',
    year: '2023',
    tags: ['헬스케어', '휴대형 가전', 'CMF'],
}

const moduInhalerShowcases = [
    {
        id: 'modu-collage',
        kicker: 'Detail',
        title: '조작부 · 충전 · 실루엣',
        tagline: 'MODU · 3단 출력',
        image: MODU_INHALER_COLLAGE_IMG,
        imageAlt:
            'MODU 콧물 흡입기 — 전체 측면, 상단 로고·전원·출력 단계(1·2·3), USB-C 충전부 디테일 콜라주',
        description: [
            '좌측 전체 뷰에서 원통형 그립·상단 투명 챔버·실리콘 노즐·스테인리스 링의 수직 비율을 확인할 수 있습니다. 슬림한 48×48 단면으로 손에 쥐기 쉬운 휴대 형태를 전제했습니다.',
            '우측 상단은 MODU 로고·전원 버튼·1·2·3단 출력 LED를 클로즈업하고, 하단은 USB-C 충전 포트가 있는 베이스를 담아 일상 충전·보관 시나리오를 표현했습니다.',
        ],
        features: [
            {
                title: '3단 출력',
                text: '1·2·3단 표시로 흡입 강도를 단계별로 조절하는 직관적 UI를 전면에 배치했습니다.',
            },
            {
                title: '스테인리스 링',
                text: '노즐 하단 메탈 링으로 프리미엄 터치포인트와 위생·내구 이미지를 동시에 전달합니다.',
            },
            {
                title: '투명 챔버',
                text: '상단 투명 컬렉션 영역으로 사용·세척 상태를 한눈에 확인할 수 있게 했습니다.',
            },
            {
                title: 'USB-C 충전',
                text: '하단 USB-C로 휴대·여행 환경에서도 범용 충전 케이블을 사용할 수 있게 설계했습니다.',
            },
        ],
    },
    {
        id: 'modu-studio',
        kicker: 'Studio',
        title: 'MODU',
        tagline: 'Runny nose inhaler',
        image: MODU_INHALER_STUDIO_IMG,
        imageAlt: 'MODU 성인 콧물 흡입기 — 원형 포디엄 스튜디오 렌더',
        description: [
            '라이트 그레이 스튜디오와 원형 포디엄 위 제품 배치로 미니멀·프리미엄 헬스케어 톤을 강조했습니다. 매트 화이트 본체와 소프트 그레이 노즐, 실버 슬라이드 스위치의 대비로 깔끔한 인상을 유지합니다.',
            '배경 원형 패널은 제품 실루엣을 분리해 시선을 집중시키며, 마케팅·상세 페이지 히어로·썸네일에 활용할 수 있는 구도입니다.',
        ],
        features: [
            {
                title: '미니멀 실루엣',
                text: '군더더기 없는 원통형 볼륨으로 욕실·침실 선반에 자연스럽게 놓입니다.',
            },
            {
                title: '슬라이드 스위치',
                text: '전면 실버 슬라이드와 블루 단계 마킹으로 출력 단계를 물리적으로 선택합니다.',
            },
            {
                title: '소프트 노즐',
                text: '그레이 실리콘 팁으로 코 접촉부의 부드러운 사용감을 시각화했습니다.',
            },
            {
                title: '프리미엄 CMF',
                text: '화이트 매트·메탈·실리콘 3재질 조합으로 생활·헬스 가전 포지셔닝을 반영했습니다.',
            },
        ],
    },
]

const moduInhalerProcessPhases = [
    {
        id: 'concept',
        title: '콘셉트 & 사용 맥락',
        lede: '휴대가 간편하고 조작이 단순한 프리미엄 성인용 콧물 흡입기를 목표로 했습니다.',
        body: 'Runny nose inhaler 콘셉트 아래 일상·출장·침실에서도 부담 없이 사용할 수 있는 소형 볼륨과 고급스러운 마감을 동시에 추구했습니다. 스테인리스 포인트로 의료·뷰티 기기 톤을 살렸습니다.',
    },
    {
        id: 'form',
        title: '형태 & 인체공학',
        lede: '48×48×190(mm) 스케일의 슬림 원통 그립과 상단 노즐 각도를 맞췄습니다.',
        body: '한 손으로 쥐고 코에 대는 동선을 전제해 본체 곡률·노즐 길이·무게 중심을 정리했습니다. PLASTIC 본체에 메탈 링·투명 챔버를 겹쳐 기능 구역을 분리했습니다.',
    },
    {
        id: 'ux',
        title: '조작 & 출력 UX',
        lede: '전원·3단 출력·슬라이드 스위치를 전면 한 영역에 모았습니다.',
        body: '출력 단계 1·2·3과 LED 피드백으로 흡입 강도를 예측 가능하게 조절합니다. 하단 USB-C는 충전 상태를 분리해 위생·사용 영역과 구분했습니다.',
    },
    {
        id: 'viz',
        title: '시각화',
        lede: 'Rhinoceros·KeyShot·Photoshop으로 시트·콜라주·스튜디오 렌더를 제작했습니다.',
        body: '좌측 카피·스펙·우측 제품 렌더가 있는 제품 시트, 3분할 디테일 콜라주, 포디엄 스튜디오 컷으로 갤러리·상세·마케팅에 맞는 산출물 세트를 구성했습니다.',
    },
]

export const moduInhalerDesignCase = {
    pageTitle: 'MODU 성인 콧물 흡입기',
    masthead: 'MODU',
    mastheadSub: 'Runny nose inhaler',
    showcaseSectionTitle: '제품 특징 · 상세',
    metaDescription:
        'MODU 성인 콧물 흡입기 — 휴대형 프리미엄 흡입기, 스테인리스 포인트, 3단 출력·USB-C, Rhino·KeyShot 제품 디자인 사례입니다.',
    meta: {
        client: "MODU'I",
        year: '2023',
        scope: '제품 디자인 · Rhinoceros · KeyShot · Photoshop',
        size: '48 × 48 × 190 (mm)',
        material: 'PLASTIC',
    },
    intro: {
        lead: '휴대가 간편하고 조작이 단순한 프리미엄 성인용 콧물 흡입기입니다. 스테인리스 소재를 활용해 고급스러운 느낌을 더했습니다.',
        left: '효과적인 코 세척·흡입을 전제로 한 현대적이고 세련된 디자인입니다. 매트 화이트 본체, 투명 상단 챔버, 실리콘 노즐, 메탈 링으로 위생·프리미엄 이미지를 동시에 전달합니다.',
        right: '제품 시트로 카피·스펙·메인 렌더를, 디테일 콜라주로 조작·충전 구조를, 스튜디오 컷으로 브랜드 톤을 각각 나누어 상세 페이지에 배치했습니다.',
    },
    hero: {
        src: MODU_INHALER_SHEET_IMG,
        alt: 'MODU 성인 콧물 흡입기 제품 시트 — Runny nose inhaler, 스펙·3D 렌더',
    },
    productShowcases: moduInhalerShowcases,
    processPhases: moduInhalerProcessPhases,
    deliverables: [
        '휴대형 흡입기 콘셉트·슬림 실루엣·노즐·챔버 구조 정리',
        'Rhinoceros 3D 모델 및 KeyShot 고해상도 렌더',
        'CMF·3단 출력 UI·슬라이드 스위치 시안',
        '제품 스펙 시트(48×48×190 mm · PLASTIC · 2023)',
        'Photoshop 프레젠테이션·디테일 콜라주·스튜디오 컷',
    ],
    outro: [
        '소형 헬스케어 기기도 시트·콜라주·스튜디오 렌더 세트로 스펙과 감성을 동시에 전달할 수 있습니다.',
        'MODU는 휴대성·프리미엄 CMF·직관적 출력 UI를 한 볼륨에 담은 제품 디자인 사례입니다.',
        '코담디자인은 생활·헬스케어 제품의 형태·CMF·렌더 시각화를 지원합니다.',
    ],
}
